import {
    CommonRoutes,
} from 'app/enums/common.enums'
import ContactsDemoPage from 'app/PoC/DataGridDemoPages/ContactsDemo'

export default [{
    path: CommonRoutes.Index,
    element: <ContactsDemoPage />,
}]
